import React from "react";
import {Button, CircularProgress} from '@material-ui/core';
import {IconButton} from "@mui/material";

export default function StandardButton(props) {

    return (<div style={{position: "relative", direction: props.direction ? props.direction : "rtl"}}
                 onClick={props.onClick}>
        <div style={{opacity: !props.loading ? 100 : 0}}>
            {props.text ?
                <Button
                    endIcon={props.icon && props.icon}
                    variant={props.variant ? props.variant : "text"}>
                    <label
                        className={props.textcolor ? "marginLeftRightSmall " + props.textcolor : "marginLeftRightSmall"}>
                        {props.text}
                    </label>
                </Button> :
                <IconButton color="primary" component="span">
                    {props.icon}
                </IconButton>
            }
        </div>
        {props.loading &&
        <div style={{position: "absolute", top: "65%", left: "50%", transform: "translate(-50%,-50%)"}}>
            <CircularProgress size={25}/>
        </div>
        }

        {(props.badgenumber && props.badgenumber > 0) &&
        <div className="smallCircle smallIcon_1 whiteColor smallText center"
             style={{position: "absolute", top: "-0.5em", right: "-0.5em"}}>
            {props.badgenumber}
        </div>
        }
    </div>)
}